import { MenuActionType } from '#baseMenu/types/MenuActionType';

class MenuActionControl {
  private actions: MenuActionType[] = [];

  add(action: MenuActionType): void {
    this.actions.push(action);
  }

  remove(id: string): void {
    this.actions = this.actions.filter((item) => item.id !== id);
  }

  hide(): Promise<void> {
    const taskList = this.actions.reverse().map((action) => action.hide);

    return new Promise((resolve) => {
      taskList.reduce(async (prev, task) => {
        await prev;
        return await task();
      }, Promise.resolve()).then(() => {
        this.actions = [];
        resolve();
      });
    });
  }
}

export { MenuActionControl };
